// extracted by mini-css-extract-plugin
module.exports = {"btnNormal":"Actions_btnNormal__1YBzq"};